import gql from "graphql-tag";

export default gql`
  query concreteFormula($id: Int!) {
    concreteFormula(id: $id) {
      id
      isActive
      code
      fcj
      fck
      use
      wcRatio
      fctmk
      mortarFactor
      observations
      incorporatedAir
      consumption
      price
      margin
      aggressivenessIndex
      version
      updatedAt
      concreteFamily {
        id
        name
        use
        cementType {
          id
          name
        }
        gravelType
        slump {
          id
          description
        }
      }
      formulaMaterials {
        id
        proportion
        weight
        specificWeight
        order
        inventoryItem {
          id
          name
          unit
          materialType
          inventoryQuantity
        }
        supplier {
          id
          name
        }
      }
    }
    inventoryItems {
      id
      name
      materialType
      unit
    }
    concreteFamilies {
      id
      name
      use
      cementType {
        id
        name
      }
      gravelType
      slump {
        id
        description
      }
    }
  }
`;

export const CONCRETE_FORMULA_CREATE_QUERY = gql`
  query {
    inventoryItems {
      id
      name
      materialType
      unit
    }
    concreteFamilies {
      id
      name
      use
      cementType {
        id
        name
      }
      gravelType
      slump {
        id
        description
      }
    }
  }
`;

export const SUPPLIERS_QUERY = gql`
  query {
    suppliers {
      id
      name
    }
  }
`;
